import React, {useEffect, useMemo, useState} from 'react';
import {Body1, Body2, Subhead2} from "../../../../../components/Font";
import {IconContainer} from "../../../../../components/ui/Content";
import {SubmitModalButton} from "../../../../../components/ui/Button";
import {useTranslation} from "react-i18next";
import {useAppDispatch, useAppSelector} from "../../../../../app/hooks";
import styled, {useTheme} from "styled-components";
import {RadioOff, RadioOn} from "../../../../../icon/Icon";
import {PhoneConfirmSuccess} from "./PhoneConfirmSuccess";
import {Popup} from "../../../../../ui/Modal/Popup";
import {SelectedConfirmationWay} from "./SelectedConfirmationWay";
import {PhoneConfirmationWay, ProcessType} from "../../../../../enum/phoneConfirm";
import {GetConfirmationWays} from "../slice";
import {LoaderContainer, LoaderEnum, MiniLoader} from "../../../../../ui/Loader/MiniLoader";
import {setPhone, setPhoneSubmit} from "../../../slice";
import {PhoneConfirmError} from "./PhoneConfirmError";

interface ConfirmPhoneModalProps {
  onClose(): void;

  onSubmit(value: PhoneConfirmationWay): void;
}

const PhoneConfirmModal = ({ onClose, onSubmit }: ConfirmPhoneModalProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const Theme = useTheme();

    const {
        selectedWay: confirmedWay,
        ways,
        errorConfirm: phoneConfirmedError,
        fetching,
        phone,
    } = useAppSelector(state => state.phoneConfirm)

    const {
      phoneSubmit: phoneConfirmed
  } = useAppSelector(state => state.auth)

  const isFetching = Object.keys(fetching).length !== 0;
  const filteredWays = useMemo(
    () => ways.filter((i) => i.id !== confirmedWay),
    [ways, confirmedWay],
  );

  const [selectedWay, setSelectedWay] = useState<PhoneConfirmationWay | null>(
    null,
  );
  const [chooseModalOpened, setChooseModalOpened] = useState(false);

  useEffect(() => {
    if (!confirmedWay) {
      dispatch(
        GetConfirmationWays({
          process_id: ProcessType.PhoneRegisterConfirmation,
        }),
      );
    }
  }, [confirmedWay]);

  useEffect(() => {
    if (filteredWays.length !== 0) {
      setSelectedWay(filteredWays[0].id);
    }
  }, [filteredWays]);

  useEffect(() => {
    if (phoneConfirmed && phone) {
      dispatch(setPhone(phone));
      dispatch(setPhoneSubmit(true));
    }
  }, [phoneConfirmed]);


  if (phoneConfirmed) {
    return <PhoneConfirmSuccess onClose={onClose} />;
  }

    if (phoneConfirmedError) {
        return <PhoneConfirmError onClose={onClose}/>
    }

    if (chooseModalOpened) {
        return (<Popup
            className="radius"
            onGoBack={() => setChooseModalOpened(false)}
            style={{
                padding: 0,
                gap: 0,
                width: 410,
                height: 'fit-content',
            }}
            opened={true}
            onClose={onClose}
            title={t('passport.registrationForm.callbackAlert.title')}
          >
            <PopupBody>
                <Subhead2 style={{marginBottom: 16, textAlign: 'start'}}>

                </Subhead2>
                <ColumnGap16>
                    {filteredWays.map(({id, title, description}) => {
                        return <ConfirmationListItem onClick={() => setSelectedWay(id)} key={id}>
                            <IconContainer>
                                {id === selectedWay ? <RadioOn/> : <RadioOff/>}
                            </IconContainer>
                            <ColumnGap2>
                                <Body2>
                                    {title}
                                </Body2>
                                <Body1 color={Theme.color.secondary}>
                                    {description}
                                </Body1>
                            </ColumnGap2>
                        </ConfirmationListItem>
                    })}
                </ColumnGap16>

          <SubmitModalButton
            disabled={!selectedWay}
            style={{ marginTop: 40 }}
            onClick={() => {
              if (selectedWay) {
                onSubmit(selectedWay);
                setChooseModalOpened(false);
              }
            }}
          >
            {t("passport.registrationForm.continueButton.name")}
          </SubmitModalButton>
        </PopupBody>
      </Popup>
    );
  }

  if (confirmedWay) {
    return (
      <SelectedConfirmationWay
        onClose={onClose}
        onChangeWay={() => setChooseModalOpened(true)}
      />
    );
  }

  if (isFetching) {
    return (
      <LoaderContainer>
        <MiniLoader color={Theme.color.indicator} size={LoaderEnum.small} />
      </LoaderContainer>
    );
  }
  return null;
};

const ConfirmationListItem = styled.div`
  display: flex;
  width: 100%;
  gap: 12px;
  cursor: pointer;
  text-align: start;
  user-select: none;
`;

const ColumnGap2 = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 2px;
`;
const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px;
`;

const ColumnGap16 = styled(ColumnGap2)`
  gap: 16px;
`;

export default PhoneConfirmModal;
